/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePlanningRequestPost } from '../../models/create-planning-request-post';
import { CreatePlanningResponse } from '../../models/create-planning-response';

export interface PlanningsControllerCreatePlanning$Params {
      body: CreatePlanningRequestPost
}

export function planningsControllerCreatePlanning(http: HttpClient, rootUrl: string, params: PlanningsControllerCreatePlanning$Params, context?: HttpContext): Observable<StrictHttpResponse<CreatePlanningResponse>> {
  const rb = new RequestBuilder(rootUrl, planningsControllerCreatePlanning.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreatePlanningResponse>;
    })
  );
}

planningsControllerCreatePlanning.PATH = '/planning-projects/v1-preview/projects/variants/plannings';
